import React, { useContext, useState } from "react";
import BackTool from "../../components/Toolnav/BackTool";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import Something from "../../components/Shared/Something";
import { handleAssignAttendee, handleFetchTraining } from "../../api/training";
import Moment from "react-moment";
import { AiOutlineCloseSquare, AiOutlinePlus } from "react-icons/ai";
import AssignCourse from "./components/AssignCourse";
import AssignAttendee from "./components/AssignAttendee";
import { AuthContext } from "../../contexts/AuthContext";
import AssignOrganizer from "./components/AssignOrganizer";
import { RiDeleteBinLine } from "react-icons/ri";
import DeleteAttendee from "./components/DeleteAttendee";
import AttendanceTaking from "./components/AttendanceTaking";
import moment from "moment";
import { BsCalendar3Week, BsCheck2Square } from "react-icons/bs";
import { handleFetchCourse } from "../../api/course";
import { Form, message } from "antd";
import RescheduleTraining from "./components/RescheduleTraining";
import DayCalendarPanel from "./components/DayCalendarPanel";
import { level2 } from "../../utils/access";

export default function OneTraining() {
  const [organizerModal, setOrganizerModal] = useState<boolean>(false);
  const [courseModal, setCourseModal] = useState<boolean>(false);
  const [enrolModal, setEnrolModal] = useState<boolean>(false);
  const [removeModal, setRemoveModal] = useState<boolean>(false);
  const [attendanceModal, setAttendanceModal] = useState<boolean>(false);
  const [rescheduleModal, setRescheduleModal] = useState<boolean>(false);
  const [dayViewModal, setDayViewModal] = useState<boolean>(false);
  const [attended, setAttended] = useState<boolean>(false);
  const [enrollment, setEnrollment] = useState<any>({});
  const [selected, setSelected] = useState<any>({});
  const [dayAttendance, seyDayAttendance] = useState<any>({});
  const { auth } = useContext(AuthContext);
  const { id } = useParams();

  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const {
    data: training,
    isError,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["allTrainings", id],
    queryFn: () => handleFetchTraining({ _id: id }),
  });

  const { data: course, refetch: courseRefetch } = useQuery({
    queryKey: ["courses", id],
    queryFn: () => handleFetchCourse({ _id: training?.payload?.course?._id }),
  });

  const { mutate } = useMutation({
    mutationFn: handleAssignAttendee,
    onSuccess: () => {
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["allTrainings", id],
      });
      queryClient.invalidateQueries({
        queryKey: ["courses", training?.payload?.course?._id],
      });
      courseRefetch();
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  if (!training) {
    return <></>;
  }

  const assignAttendee = async ({ item }: any) => {
    const data = {
      name: item?.name,
      email: item?.email,
      mobile: item?.mobile,
      company: item?.company,
      user: item?._id,
      manager: auth?._id,
    };

    await mutate({ _id: id, data });
  };

  const start = Number(moment(training?.payload?.start).format("YYYYMMDD"));
  const end = Number(moment(training?.payload?.end).format("YYYYMMDD"));

  let attendance: any = [];

  for (let currentDate: any = start; currentDate <= end; currentDate++) {
    let date: any = currentDate.toString();
    let a = training?.payload?.attendance[currentDate];
    if (a !== undefined) {
      const d = {
        date: date,
        data: a,
      };
      attendance.push(d);
    }
  }


  console.log(attendance, ":::::: >>>> <<<< :::::::")

  return (
    <div>
      <BackTool menus={[{ id: 1, name: "Member", to: "/members" }]} />
      {isError ? (
        <Something refetch={refetch} isFetching={isFetching} />
      ) : (
        <div className="p-2">
          <div className="border bg-white">
            <div className="border-b border-gray-300 mb-1 bg-white flex text-sm">
              <div className="p-2 flex flex-col justify-center items-center bg-white w-44">
                <div className="">
                  <Moment format="Do MMM, YYYY">
                    {training?.payload?.start}
                  </Moment>
                </div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
                <div className="h-10 bg-gray-300 border-r-2 border-gray-300"></div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
                <div className="">
                  <Moment format="Do MMM, YYYY">
                    {training?.payload?.end}
                  </Moment>
                </div>
              </div>
              <div className="flex justify-between w-full">
                <div className="border-l p-2 bg-gray-50 flex-1">
                  <div className="text-lg border-b pb-2 text-blue-900">
                    <span className="font-bold">Training : </span>
                    {training?.payload?.title}
                  </div>
                  <div className="py-1 text-lg italic flex items-center">
                    Organizer : {training?.payload?.organizer[0]?.name || ""}
                  </div>
                  <div className="flex items-center">
                    <div className="flex flex-col">
                      <div className="text-gray-600">
                        Start Date:{" "}
                        <Moment format="Do MMM, YYYY">
                          {training?.payload?.start}
                        </Moment>
                      </div>
                      <div className="text-gray-600">
                        End Date:{" "}
                        <Moment format="Do MMM, YYYY">
                          {training?.payload?.end}
                        </Moment>
                      </div>
                    </div>
                    {level2?.includes(auth?.role) && (
                      <button
                        onClick={() => setRescheduleModal(true)}
                        className="ml-2 border border-gray-300 p-2 flex items-center"
                      >
                        <BsCalendar3Week />
                        <span className="ml-1">Reschedule</span>
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex flex-col justify-center items-center px-8">
                  <div className="text-3xl">
                    {training?.payload?.enrolled?.length}
                  </div>
                  <div className="">Attendee(s)</div>
                </div>
              </div>
            </div>

            <div className="">
              <div className="p-2">
                <div className="pb-2 border-b flex justify-between">
                  <div className="">Course</div>
                  {level2?.includes(auth?.role) && (
                    <button
                      onClick={() => setCourseModal(true)}
                      className="border py-1 px-4 text-xs flex items-center"
                    >
                      <AiOutlinePlus /> <span>Update Course</span>
                    </button>
                  )}
                </div>
                {training?.course === null ? (
                  <div className="flex justify-center items-center my-8">
                    <div className="text-gray-500">No Courses Found</div>
                  </div>
                ) : (
                  <div className="mb-8">
                    <div className="flex flex-col text-gray-600 text-sm">
                      <div className="flex">
                        <div className="flex flex-1">
                          <div className="py-2 text-lg text-black">
                            Title : {training?.payload?.course?.name}
                          </div>
                        </div>
                      </div>
                      <div className="ml-12">
                        <div className="">Instructors</div>
                        {training?.payload?.instructors?.map(
                          (inst: any, index: number) => (
                            <div className="flex items-center" key={index}>
                              <span className="">- {inst?.name}</span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="">
              <div className="p-2">
                <div className="pb-2 border-b flex justify-between">
                  <div className="">Enrollment</div>
                  {level2?.includes(auth?.role) && (
                    <button
                      onClick={() => setEnrolModal(true)}
                      className="border py-1 px-4 text-xs flex items-center"
                    >
                      <AiOutlinePlus /> <span>Add Attendee</span>
                    </button>
                  )}
                </div>
                <div className="mb-8">
                  <div className="border-t border-r border-l border-b-4 flex justify-between items-center">
                    <div className="flex">
                      <div className="w-12 p-2 border-r">S/N</div>
                      <div className="w-72 p-2 border-r">NAME</div>
                      {/* <div className="w-72 p-2">EMAIL</div> */}
                      <div className="w-48 p-2 border-l">MOBILE</div>
                      <div className="w-48 p-2 border-l">FROM</div>
                    </div>
                    <div className="flex">
                      <div className="w-48 p-2 border-l">ATTENDING</div>
                      {level2?.includes(auth?.role) && (
                        <div className="w-48 p-2 border-l">ATTENDENCE</div>
                      )}
                    </div>
                  </div>
                  {training?.payload?.enrolled?.map(
                    (item: any, index: number) => (
                      <div
                        className="flex justify-between border text-gray-600 text-sm"
                        key={index}
                      >
                        <div className="flex">
                          <div className="w-12 border-r p-2 text-center">
                            {index + 1}
                          </div>
                          <div className="w-72 border-r p-2">{item?.name}</div>
                          {/* <div className="w-72 p-2">{item?.email}</div> */}
                          <div className="w-48 p-2 border-l">
                            {item?.mobile}
                          </div>
                          <div className="w-48 p-2 border-l">
                            {item?.company?.name}
                          </div>
                        </div>
                        <div className="flex">
                          <div className="w-48 border-l flex">
                            <div className="w-32  p-2">
                              {item?.canAttend ? "YES" : "NO"}
                            </div>
                            {auth?.company?.name === item?.company?.name && (
                              <button
                                onClick={() => {
                                  setSelected(item);
                                  setRemoveModal(true);
                                }}
                                className="w-16 border-l p-2"
                              >
                                <RiDeleteBinLine color="red" />
                              </button>
                            )}
                          </div>
                          {level2?.includes(auth?.role) && (
                            <div className="w-48 border-l flex justify-center items-center">
                              <div className="flex h-6">
                                <button
                                  onClick={() => {
                                    setAttended(true);
                                    setEnrollment(item);
                                    setAttendanceModal(true);
                                  }}
                                  className="border border-green-400 bg-green-200 flex justify-center items-center mx-2 px-2 cursor-pointer"
                                >
                                  Present
                                </button>
                                <button
                                  onClick={() => {
                                    setAttended(false);
                                    setEnrollment(item);
                                    setAttendanceModal(true);
                                  }}
                                  className="border border-red-400 bg-red-200 flex justify-center items-center px-2 cursor-pointer"
                                >
                                  Absent
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>

              {/* WISHLIST */}
              <div className="p-2">
                <div className="flex justify-between pt-4 pb-2 border-b-4 mb-2">
                  <div className="font-bold">Wishlist</div>
                </div>
                <div className="mb-8">
                  <div className="border-t border-r border-l border-b-4 flex justify-between items-center">
                    <div className="flex">
                      <div className="w-12 p-2 border-r">S/N</div>
                      <div className="w-72 p-2 border-r">NAME</div>
                      <div className="w-72 p-2">EMAIL</div>
                    </div>
                    <div className="flex items-center">
                      <div className="w-48 p-2 border-l">MOBILE</div>
                      <div className="w-48 p-2 border-l">ASSIGN</div>
                    </div>
                  </div>
                  {course?.payload?.wishList?.map(
                    (item: any, index: number) => (
                      <div
                        className="flex justify-between border text-gray-600 text-sm"
                        key={index}
                      >
                        <div className="flex">
                          <div className="w-12 border-r p-2 text-center">
                            {index + 1}
                          </div>
                          <div className="w-72 border-r p-2">{item?.name}</div>
                          <div className="w-72 p-2">{item?.email}</div>
                        </div>
                        <div className="flex items-center">
                          <div className="w-48 p-2 border-l">
                            {item?.mobile}
                          </div>
                          <div className="w-48  border-l p-1">
                            <button
                              onClick={() => assignAttendee({ item })}
                              className=" bg-gray-200 p-2 cursor-pointer flex items-center justify-center"
                            >
                              ASSIGN
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>

              {/* ATTENDANCE */}
              <div className="p-2">
                <div className="font-bold mb-2">ATTENDANCE</div>
                {attendance?.map((item: any, index: number) => (
                  <div className="mb-4" key={index}>
                    <div className="border-b border-gray-500 bg-blue-100 text-lg p-2 flex justify-between">
                      <Moment format="DD/MM/YYYY">{item?.date}</Moment>
                      {level2?.includes(auth?.role) && (
                        <button
                          onClick={() => {
                            seyDayAttendance(item);
                            setDayViewModal(true);
                          }}
                          className="border border-blue-500 px-2 py-1 text-xs"
                        >
                          View
                        </button>
                      )}
                    </div>
                    <div className="ml-4">
                      {item?.data?.map((attendee: any, index: number) => (
                        <div
                          className="flex justify-between border-b pb-1 mt-2"
                          key={index}
                        >
                          <div className="flex">
                            <div className="w-12">{index + 1}.</div>
                            <div className="">{attendee?.name}</div>
                          </div>
                          <div className="flex items-center">
                            {attendee?.reason && (
                              <div className="">
                                <span className="text-red-400">Reason:</span>{" "}
                                {attendee?.reason}
                              </div>
                            )}
                            <div className="w-32 ml-4">
                              {attendee?.attended ? (
                                <div className="flex justify-start items-center ">
                                  <BsCheck2Square size={22} color="#16a34a" />
                                  <span className="ml-2">PRESENT</span>
                                </div>
                              ) : (
                                <div className="flex justify-start items-center">
                                  <AiOutlineCloseSquare
                                    size={24}
                                    color="#dc2626"
                                  />
                                  <span className="ml-2">ABSENT</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <AssignCourse
            isVisible={courseModal}
            setVisible={setCourseModal}
            training_id={id}
          />

          <AssignAttendee
            isVisible={enrolModal}
            setVisible={setEnrolModal}
            training_id={id}
            courseRefetch={courseRefetch}
          />
          <AssignOrganizer
            isVisible={organizerModal}
            setVisible={setOrganizerModal}
            training_id={id}
          />

          <DeleteAttendee
            isVisible={removeModal}
            setVisible={setRemoveModal}
            training_id={id}
            selected={selected || {}}
          />

          <AttendanceTaking
            enrollment={enrollment}
            training_id={id}
            attended={attended}
            isVisible={attendanceModal}
            setVisible={setAttendanceModal}
          />

          <RescheduleTraining
            training_id={id}
            isVisible={rescheduleModal}
            setVisible={setRescheduleModal}
          />

          <DayCalendarPanel
            training={training?.payload || {}}
            attendance={dayAttendance || {}}
            isVisible={dayViewModal}
            setVisible={setDayViewModal}
          />
        </div>
      )}
    </div>
  );
}
